export const HomeData = [{

        title: 'Notícias do dia',
        title2: 'Palavras Chaves',
        title3: 'Visitados Recentemente',
        description: 'Veja as últimas notícias até o momento',
    }
]
